import { MediaFile } from "@models/mediaFile.model";
import { resolvePreviewMedia, type ImageContent, type VideoContent, type SMSContent } from "@models/Ad.model";
import { CommandGetMedia } from "./commands/cmdGetMedia";
import { CommandUploadMedia } from "./commands/cmdUploadMedia";
import { CommandResolveAds, type ResolveAdsOut, type ResolvedAdContent, type ResolveAdsRawOut } from "./commands/cmdResolveAds";
import { CommandListMedia, type ListMediaResponse } from "./commands/cmdListMedia";

export class MediaService {
    async getMedia(mediaId: number): Promise<MediaFile> {
        const cmd = new CommandGetMedia();
        return cmd.run(mediaId);
    }

    async listMedia(params: { file_type?: string; extension?: string; exclude_extension?: string; name?: string; page?: number; page_size?: number; uploaded_by?: number } = {}): Promise<ListMediaResponse> {
        const cmd = new CommandListMedia();
        return cmd.run(params);
    }

    async uploadMedia(file: File, name?: string, metadata?: Record<string, any>, onProgress?: (percentage: number) => void): Promise<MediaFile> {
        const cmd = new CommandUploadMedia();
        return cmd.run(file, name, metadata, onProgress);
    }

    async resolveAds(adIds: number[]): Promise<ResolveAdsRawOut> {
        const cmd = new CommandResolveAds();
        return cmd.run(adIds);
    }

    async resolveAdDisplay(adIds: number[]): Promise<ResolveAdsOut> {
        const rawResolved = await this.resolveAds(adIds);

        const resolved: Record<number, ResolvedAdContent | null> = {};
        for (const [adIdStr, leaf] of Object.entries(rawResolved)) {
            const adId = Number(adIdStr);
            if (!leaf) {
                resolved[adId] = null;
                continue;
            }
            const c = leaf.content as (VideoContent | ImageContent | SMSContent) | undefined;
            const media = (c && (("video" in c && c.video) || ("image" in c && c.image))) || null;
            const preview = resolvePreviewMedia(c);
            resolved[adId] = { ad: leaf, media, preview };
        }

        return { resolved };
    }
}
